export default "__VITE_PUBLIC_ASSET__909e3869__"